import { useQueries } from "@tanstack/react-query";

import { DefaultFetchService } from "app/services/fetchService";
import type { ICategory } from "app/common/services/categoryService.types";

const ENDPOINT = "/api/MarketDistribution/PieChart";

interface IMarketDistributionData {
    Data: any; // TODO: Add proper typing
}

export const useMarketDistributionData = (categories: ICategory[], country: string, webSource: string) => {
    return useQueries({
        queries: categories.map((category) => {
            const enabled = !!country && !!webSource && !!category.forApi && !category.isCustomCategory;
            return {
                queryKey: ["marketDistribution", category.id, country, webSource],
                queryFn: async (): Promise<IMarketDistributionData> => {
                    // Custom parameters for market distribution API
                    const customParams: Record<string, unknown> = {};
                    customParams["Country"] = country;
                    customParams["WebSource"] = webSource;
                    customParams["Keys"] = [category.forApi];
                    customParams["category"] = category.categoryId;
                    customParams["includeSubDomains"] = true;
                    const fetchService = DefaultFetchService.getInstance();
                    const response = await fetchService.get<IMarketDistributionData>(ENDPOINT, customParams);
                    return response;
                },
                enabled,
            };
        }),
        combine: (results) => ({
            data: results.map((result) => result.data),
            isLoading: results.some((result) => result.isLoading),
            isError: results.some((result) => result.isError),
            error: results.find((result) => result.error)?.error || null,
        }),
    });
};
